import React from 'react';
import TeaserProduct from './TeaserProduct';
import TeaserNode from './TeaserNode';

export default function SearchResult(props) {
  if ('variation_id_processed' in props.hit) {
    return (
      <TeaserProduct hit={props.hit}/>
    )
  }
  else {
    return (
      <TeaserNode hit={props.hit}/>
    )
  }
}
